import { render, staticRenderFns } from "./GrupoUsuarioView.vue?vue&type=template&id=3024e391"
import script from "./GrupoUsuarioView.vue?vue&type=script&lang=js"
export * from "./GrupoUsuarioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports